export default class Scanner {
  constructor() {
    this.buffer = '';
    this.type = null;
    this.scanning = false;
  }

  parseData(selectedBrand) {
    const refNumType = 'referenceNumber';
    const serialType = 'serialNumber';

    if (selectedBrand === 'Sientra') {
      if (this.buffer.match(/^(240|106|107)\d+-\d+\w+\]$/)) {
        console.log('sentra ref found');
        this.buffer = this.buffer.slice(3, -1);
        this.type = refNumType;
      } else if (this.buffer.match(/^21\d+-?\d*\]$/)) {
        console.log('sentra serial found');
        this.buffer = this.buffer.slice(2, -1);
        this.type = serialType;
      }
    } else if (selectedBrand === 'Mentor') {
      if (
        this.buffer.match(/^SMHB-\d+\]$/) ||
        this.buffer.match(/^SMPB\d+\]$/) ||
        this.buffer.match(/^SHPB\d+\]$/)
      ) {
        console.log('mentor ref found');
        if (this.buffer.startsWith('SMPB')) {
          this.buffer = this.buffer.replace('SMPB', 'SMPB-').slice(0, -1);
        } else if (this.buffer.startsWith('SHPB')) {
          this.buffer = this.buffer.replace('SHPB', 'SHPB-').slice(0, -1);
        } else {
          this.buffer = this.buffer.slice(0, -1);
        }
        this.type = refNumType;
      } else if (this.buffer.match(/^\d+-\d+\]$/)) {
        console.log('mentor serial found');
        this.buffer = this.buffer.slice(0, -1);
        this.type = serialType;
      }
    } else if (selectedBrand === 'Motiva') {
      if (
        this.buffer.match(/^ERSM-\d{3}\]$/) ||
        this.buffer.match(/^RSM-\d{3}\+\]$/) ||
        this.buffer.match(/^RSD-\d{3}\+\]$/) ||
        this.buffer.match(/^ERSD-\d{3}\+\]$/) ||
        this.buffer.match(/^ERSF-\d{3}\+\]$/) ||
        this.buffer.match(/^RSM-\d{3}\]$/) ||
        this.buffer.match(/^RSD-\d{3}\]$/) ||
        this.buffer.match(/^ERSD-\d{3}\]$/) ||
        this.buffer.match(/^ERSF-\d{3}\]$/)
      ) {
        console.log('motiva ref found');
        this.buffer = this.buffer.slice(0, -1);
        this.type = refNumType;
      } else if (this.buffer.match(/^\d+-\d+\]$/)) {
        console.log('motiva serial found');
        this.buffer = this.buffer.slice(0, -1);
        this.type = serialType;
      }
    } else if (selectedBrand === 'Allergan') {
      if (
        this.buffer.match(/^\d{2}-\d{3}\]$/) ||
        this.buffer.match(/^SCF-\d{3}\+\]$/) ||
        this.buffer.match(/^SCX-\d{3}\+\]$/) ||
        this.buffer.match(/^SSX-\d{3}\+\]$/) ||
        this.buffer.match(/^SCF-\d{3}\]$/) ||
        this.buffer.match(/^SCX-\d{3}\]$/) ||
        this.buffer.match(/^SSX-\d{3}\]$/)
      ) {
        console.log('allergan ref found');
        this.buffer = this.buffer.slice(0, -1);
        this.type = refNumType;
      } else if (this.buffer.match(/^\d+\]$/)) {
        console.log('allergan serial found');
        this.buffer = this.buffer.slice(0, -1);
        this.type = serialType;
      }
    }
    // else if (this.buffer.match(/^[A-Z]{4}-\d+\]$/)) {
    //   console.log('allergan or motiva ref found');
    //   this.buffer = this.buffer.slice(0, -1);
    //   this.type = refNumType;
    // } else if (this.buffer.match(/^[A-Z]{4}\d+\]$/)) {
    //   console.log('allergan or motiva ref found');
    //   this.buffer = this.buffer.slice(0, -1);
    //   this.type = refNumType;
    // } else if (this.buffer.match(/^[A-Z]{3}-\d+\]$/)) {
    //   console.log('allergan ref found');
    //   this.buffer = this.buffer.slice(0, -1);
    //   this.type = refNumType;
    // } else if (this.buffer.match(/^[A-Z]{3}-\d+\+\]$/)) {
    //   console.log('motiva rsf reference number found');
    //   this.buffer = this.buffer.slice(0, -1);
    //   this.type = refNumType;
    // } else if (this.buffer.match(/^\d+-?\d*\]$/)) {
    //   console.log('possibly motiva, allergan, or mentor serial found');
    //   this.buffer = this.buffer.slice(0, -1);
    //   this.type = serialType;
    // } else if (this.buffer.match(/^\d*\]$/)) {
    //   console.log('motiva variant?');
    //   this.buffer = this.buffer.slice(0, -1);
    //   this.type = serialType;
    // }
    // else if (this.buffer.match(/^(ssx|SSX)-\d+\]$/)) {
    //   console.log('allergan ref found');
    //   this.buffer = this.buffer.slice(4, -1);
    //   this.type = 'referenceNumber';
    // }
    else {
      console.log('no valid data found', selectedBrand, this.buffer);
    }
  }

  handleKeyPress(event) {
    if (event.key === '[' && !this.scanning) {
      console.log('scan beginning');

      this.buffer = '';
      this.type = null;
      this.scanning = true;

      setTimeout(() => {
        console.log('in timeout');

        this.buffer = '';
        this.type = null;
        this.scanning = false;
      }, 1000);
    } else if (this.scanning) {
      this.buffer = this.buffer + event.key.toUpperCase();
    }
  }
}
